/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Severitymisseddeadline2Inputs */

const en_severitymisseddeadline2 = /** @type {(inputs: Severitymisseddeadline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Missed deadline`)
};

const pt_severitymisseddeadline2 = /** @type {(inputs: Severitymisseddeadline2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prazo falhado`)
};

/**
* | output |
* | --- |
* | "Missed deadline" |
*
* @param {Severitymisseddeadline2Inputs} inputs
* @param {{ locale?: "en" | "pt" }} options
* @returns {LocalizedString}
*/
const severitymisseddeadline2 = /** @type {((inputs?: Severitymisseddeadline2Inputs, options?: { locale?: "en" | "pt" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Severitymisseddeadline2Inputs, { locale?: "en" | "pt" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_severitymisseddeadline2(inputs)
	return pt_severitymisseddeadline2(inputs)
});
export { severitymisseddeadline2 as "severityMissedDeadline" }